import React from 'react'
import { CardContainer, IconContainer, RightIconContainer } from './styled'
import { useHistory } from "react-router-dom";
import { Text2 } from '../../../styles/generics';
import theme from '../../../styles/theme';

const QuickAccessCard = ({ text, leftIcon, righIcon, urlRedirect, onClick, type = 'default' }) => {

	const history = useHistory();

	const handleClick = () => {
		if (onClick) {
			onClick();
			return;
		}

		if (urlRedirect) history.push(urlRedirect);
	};

	return (
		<CardContainer onClick={handleClick} $type={type}>
			<IconContainer>
				{leftIcon}
				<Text2 color={theme.colors.text.primaryText}>{text}</Text2>
			</IconContainer>
			<RightIconContainer>{righIcon}</RightIconContainer>
		</CardContainer>
	)
}

export default QuickAccessCard;
